import React from 'react';
import { Badge } from '@emorg-prd/standard-react';
import './POROperationBadge.css'

interface POROperationBadgeProps {
	children: string;
}

const POROperationBadge = ({ children }: POROperationBadgeProps) => {
	const getType = () => {
		switch (children) {
			case 'Add':
				return undefined
			case 'Modify':
				return "em-c-badge--caution";
			case 'Remove':
				return "em-c-badge--negative";
			case 'Keep':
				return "em-c-badge--positive";
			default:
				return undefined;
		}
	};

	const getText = () => {
		switch (children) {
			case 'Add':
				return 'new';
			case 'Modify':
				return 'modify';
			case 'Remove':
				return 'delete';
			default:
				return children;
		}
	};
	
	const getOptionalClass = () => {
		if (children !== 'Add' && children !== 'Modify' && children !== 'Remove' && children !== 'Keep') return 'operation-badge--neutral';
		return '';
	};


	return (
		<Badge type={getType()} optionalClass={`em-u-max-width-10 operation-badge ${getOptionalClass()}`} text={getText()} />
	);
};

export default POROperationBadge;